export default {
  getPackingListPallet: (state) => state.packingListPallet,
};
